import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { useEffect } from "react";
import { TUserRole } from "@/zapi-frontend/pages/SettingsPage/services/schemas";
import { syncPostHogConsent } from "@/zapi-frontend/app/providers/analytics";

type User = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  organizationId: number;
  organizationName: string | null;
  featurePermissionLevel: number;
  role: TUserRole;
  customSnippetsUrl: string | null;
  profileImageUrl: string | null;
  organizationLogoUrl: string | null;
};

export const useAuthenticated = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["session-verify"],
    queryFn: async (): Promise<User | null> => {
      try {
        const response = await $api.post("/auth/verify");
        return response?.data?.data as User;
      } catch {
        return null;
      }
    }
  });

  const { setMe } = useMeStore();

  useEffect(() => {
    if (data) {
      setMe({
        ...data,
        isLabs: data.featurePermissionLevel === 1,
        customSnippetsUrl: data.customSnippetsUrl,
        refetch: async () => {
          await refetch();
        }
      });
      syncPostHogConsent(data.id);
    }
  }, [data, setMe, refetch]);

  return { data: !!data?.email, isLoading, refetch, me: data };
};
